// Runtime settings, fetched from /config.json. The CDK stack writes it at
// deploy time; mock mode's dev server answers { "mock": true }.

export type AppConfig =
  | { mock: true }
  | {
      mock?: false;
      apiUrl: string;
      cognitoDomain: string;
      clientId: string;
      region: string;
      /** Sign in with Xero: the web client goes straight to this identity provider. */
      identityProvider?: string;
      /** Break-glass native sign-in (Cognito password + TOTP), used with /?signin=admin. */
      adminClientId?: string;
    };

export async function loadConfig(): Promise<AppConfig> {
  const res = await fetch('/config.json', { cache: 'no-store' });
  if (!res.ok) throw new Error(`Could not load /config.json (${res.status})`);
  const config = (await res.json()) as AppConfig;
  if (!config.mock && (!config.apiUrl || !config.cognitoDomain || !config.clientId)) throw new Error('config.json is missing apiUrl, cognitoDomain or clientId');
  return config;
}
